import {
  appsBomApiGetStructureTree,
  getAppsBomApiGetStructureTreeQueryKey,
} from '@/lib/api/generated/endpoints'
import type { StructureTreeOut } from '@/lib/api/generated/types.ts/structureTreeOut'
import { queryOptions } from '@tanstack/react-query'

/**
 * Single normalized-tree fetch for the nomenclature page. Returns flat
 * `assemblies` / `parts` / `materials` lists with id-references — the
 * frontend builds Maps once and recurses by lookup (see `use-tree-flatten`).
 *
 * orval's customFetch returns the parsed JSON body directly (per
 * `lib/api/fetcher.ts`); we cast at queryFn level — the runtime shape matches
 * `StructureTreeOut`.
 */
export const nomenclatureTreeQuery = (projectId: number) =>
  queryOptions({
    queryKey: getAppsBomApiGetStructureTreeQueryKey(projectId),
    queryFn: async ({ signal }) =>
      (await appsBomApiGetStructureTree(projectId, undefined, {
        signal,
      })) as unknown as StructureTreeOut,
    staleTime: 30_000,
    enabled: Number.isFinite(projectId) && projectId > 0,
  })
